var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8C13.75 10.0711 12.0711 11.75 10 11.75C7.92893 11.75 6.25 10.0711 6.25 8C6.25 5.92893 7.92893 4.25 10 4.25C12.0711 4.25 13.75 5.92893 13.75 8Z",
    fill: "#1C2743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5ZM10 1.75C5.16751 1.75 1.25 5.66751 1.25 10.5C1.25 12.5668 1.96657 14.4662 3.16483 15.9634C4.05366 14.5316 6.0058 13 10 13C13.9942 13 15.9463 14.5316 16.8352 15.9634C18.0334 14.4662 18.75 12.5668 18.75 10.5C18.75 5.66751 14.8325 1.75 10 1.75Z",
    fill: "#1C2743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUserCircle);
export default __webpack_public_path__ + "static/media/ico-user-circle.11f3f267111fc61fa5f076da51fd3758.svg";
export { ForwardRef as ReactComponent };